import { TFunction } from "@/types";

type SortByType = "ASC" | "DESC";

export interface SortItem {
  text: string;
  order: SortByType;
  columns: string;
}

export interface SortItem {
  text: string;
  order: SortByType;
  columns: string;
}

export const getSortOptions = (t?: TFunction): SortItem[] => [
  {
    text: t?.("alphabeticallyAZ") ?? "Alphabetically (A - Z)",
    columns: "name",
    order: "ASC",
  },
  {
    text: t?.("reverseAlphabeticallyZA") ?? "Reverse Alphabetically (Z - A)",
    columns: "name",
    order: "DESC",
  },
  {
    text: t?.("priceLowHigh") ?? "Price (Low - High)",
    columns: "price",
    order: "ASC",
  },
  {
    text: t?.("priceHighLow") ?? "Price (High - Low)",
    columns: "price",
    order: "DESC",
  },
];
